<template>
  <el-dialog
    :title="lang.upload_image"
    :visible.sync="dialog_flag"
    center
		class="UploadAvatar"
    :show-close="false"
    :append-to-body="true"
  >
    <el-upload
      :file-list="fileList"
      style="display: none"
      action="https://gtp.cocorobo.cn/upload"
      accept=".png,.jpg,.jpeg"
      :on-change="onChange"
      :auto-upload="false"
      ref="upload_avatar"
    >
      <div class="upload-div">
        <i class="iconfont icon-icon-shangchuan"></i>
        {{ lang.scwd }}
      </div>
    </el-upload>
    <div class="a-d-t-right poin">
      <span @click.stop="close()">×</span>
    </div>
    <div class="select_network" v-if="is_network">
      <div class="flex_x">
        <el-input v-model="image_key" placeholder="搜索图片关键字">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search_image()"
          ></el-button>
        </el-input>
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="search_image()"
          >{{ lang.Load_More }}</el-button
        >
      </div>
      <div
        v-loading="search_image_loading"
        element-loading-spinner="el-icon-loading"
        class="flex_x_cen"
        style="
          width: 100%;
          min-height: 200px;
          margin-top: 20px;
          flex-wrap: wrap;
        "
      >
        <div
          v-for="(item, index) of image_arr"
          :key="index"
          style="margin: 5px; cursor: pointer"
          @click="select_network_image(item.image)"
        >
          <img
            :src="item.image"
            width="200"
            height="150"
            style="object-fit: cover"
          />
        </div>
      </div>
      <div class="dialog-footer">
        <span slot="footer">
          <el-button size="small" type="primary" @click="is_network = false">{{
            lang.Return
          }}</el-button>
        </span>
      </div>
    </div>
    <div class="flex_x_sa" v-else>
      <div>
        <el-button type="primary" @click="local()">{{
          lang.Upload_local_files
        }}</el-button>
      </div>
      <div>
        <el-button type="primary" @click="network()">{{
          lang.Select_network_files
        }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Axios from 'axios';
export default {
  props: {
    editName: String,
  },
  watch: {
    is_network(newValue) {
      if (newValue) {
        this.search_image_page = 0;
        this.search_image();
      }
    },
  },
  data() {
    return {
      dialog_flag: true,
      fileList: [],
      image_key: '',
      image_arr: [],
      search_image_page: 0,
      is_network: false,
      search_image_loading: false,
      upload_avatar: null,
    };
  },
  mounted() {
    this.image_key = this.editName;
  },
  methods: {
    select_network_image (url) {
      this.$emit('change_avatar_url', url)
      this.$emit('changeAvatarFlag', false)
    },
    close() {
      this.$emit('changeAvatarFlag', false);
    },
    local() {
      this.$refs.upload_avatar.$children[0].handleClick();
    },
    network() {
      this.is_network = true;
    },
    onChange(nfile) {
      if (nfile.size > 10000000) {
        alert('上传的图片不能大于10M');
        return false;
      }
      var file = nfile.raw;
      let fileType2 = nfile.name.split('.');
      let fileType = fileType2[fileType2.length - 1];
      let timestamp = new Date().getTime();
      var credentials = {
        accessKeyId: 'AKIATLPEDU37QV5CHLMH',
        secretAccessKey: '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',
      };
      window.AWS.config.update(credentials);
      window.AWS.config.region = 'cn-northwest-1'; //璁剧疆鍖哄煙
      var bucket = new window.AWS.S3({
        params: {
          Bucket: 'ccrb',
        },
      }); //閫夋嫨妗�
      //console.log(nfile);
      var params = {
        Key: file.name.split('.')[0] + timestamp + '.' + fileType,
        ContentType: file.type,
        Body: file,
        'Access-Control-Allow-Credentials': '*',
        ACL: 'public-read',
      }; //key鍙互璁剧疆涓烘《鐨勭浉鎶佃矾寰勶紝Body涓烘枃浠讹紝 ACL鏈€濂借璁剧疆
      var options = {
        partSize: 2048 * 1024 * 1024,
        queueSize: 2,
        leavePartsOnError: true,
      };
      bucket
        .upload(params, options)
        .on('httpUploadProgress', function (evt) {
          //杩欓噷鍙互鍐欒繘搴︽潯
          evt;
          // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
        })
        .send((err, data) => {
          if (data) {
            this.$emit('change_avatar_url', data.Location);
            this.$emit('changeAvatarFlag', false);
          } else {
            console.log(err);
          }
        });
    },
    search_image() {
      if (this.image_key == '') {
        this.$message.error(this.lang.srnr);
        return;
      }
      this.search_image_loading = true;
      this.search_image_page++;
      const config = {
        method: 'post',
        url: 'https://gpt.cocorobo.cn/search_image',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          page: this.search_image_page,
          pagesize: 9,
          query: this.image_key,
        },
      };
      Axios(config)
        .then((response) => {
          try {
            this.image_arr = response.data.FunctionResponse.result;
            this.search_image_loading = false;
          } catch (error) {
            console.log(error);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>

.UploadAvatar >>> .el-dialog {
	width: 800px;
	border-radius: 10px;
}

.UploadAvatar >>> .el-dialog__body {
	width: 800px;
	height: auto;
	box-sizing: border-box;
	border-top: solid 1px #f3f7fd;
}

.UploadAvatar >>> .el-dialog__header {
	width: 800px;
	height: 40px;
}

.UploadAvatar >>> .el-dialog__footer {
	width: 800px;
}


.a-d-t-right {
  position: absolute;
  top: 10px;
  right: 10px;
}
.dialog-footer {
  text-align: end;
  margin-top: 30px;
}

@media screen and (max-width: 640px) {
}
</style>
